<template>
  <div class="footer">
    <div class="version">
      <b>Version</b> {{ version }}
    </div>
    <div>Copyright © 2019 快鱼IT All rights reserved.</div>
  </div>
</template>

<script type="text/babel">
import constants from 'config/constants'

export default {
  name: 'KyFooter',
  data () {
    return {
      version: constants.basic.version,
      siteName: constants.basic.siteName
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.footer
  padding: 5px
  font-size: 10px
  background: #fff;
  color: #444
  border-top: 1px solid #d2d6de
  .version
    float: right
</style>



// WEBPACK FOOTER //
// src/components/KyFooter.vue